import {
  IsBoolean,
  IsDate,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
  MinLength,
} from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { MerchantPrinterDto } from './merchantPrinter.dto';
import { PosDeviceTypeDto } from './posDeviceType.dto';
import { UserDto } from './user.dto';
import { ApiKeyDto } from './apiKey.dto';

export class PosDeviceDto extends BaseDto {
  @IsString()
  name: string;

  @IsBoolean()
  @IsOptional()
  enabled: boolean;

  @IsBoolean()
  @IsOptional()
  isAssigned: boolean;

  @IsBoolean()
  @IsOptional()
  isVirtual: boolean;

  @IsOptional()
  connection: any;

  @IsOptional()
  terminalConnection: any;

  @IsNumber()
  customerId?: number;

  @IsString()
  @IsOptional()
  device: string;

  @IsOptional()
  @IsNumber()
  cardPaymentTerminalsNo: number;

  @IsString()
  @IsOptional()
  hardwareModel: string;

  @IsString()
  @IsOptional()
  serialNumber: string;

  @IsDate()
  @IsOptional()
  verifiedDate?: Date;

  @IsDate()
  @IsOptional()
  disabledDate?: Date;

  @IsNumber()
  merchantId?: number;

  @IsNumber()
  merchantGroupId?: number;

  @IsNumber()
  userId?: number;

  @IsNumber()
  costCentreId?: number;

  @IsNumber()
  @IsOptional()
  posDeviceTypeId?: number;

  @IsString()
  @IsOptional()
  anyDeskId: string;

  @IsString()
  @IsOptional()
  anyDeskPassword: string;

  @IsString()
  pedDeviceName?: string;

  /** Bank Terminal ID */
  @IsOptional()
  @IsString()
  @MinLength(1)
  @MaxLength(64)
  bankTerminalId?: string;

  /** Bank Merchant ID */
  @IsOptional()
  @IsString()
  @MinLength(1)
  @MaxLength(64)
  bankMID?: string;

  /** SweetFace Terminal ID */
  @IsOptional()
  @IsNumber()
  sweetFaceTerminalId?: number;

  @IsOptional()
  @IsBoolean()
  isSurfboard?: boolean;

  @IsOptional()
  @IsBoolean()
  isSurfboardOnline?: boolean;

  @IsOptional()
  @IsString()
  @MaxLength(100)
  surfboardTerminalId?: string;

  till: PosDeviceDto;
  merchant?: MerchantDto;
  user?: UserDto;
  merchantGroup?: MerchantGroupDto;
  cashRegisterPrinter: MerchantPrinterDto;
  posDeviceType?: PosDeviceTypeDto;
  apiKey?: ApiKeyDto;
}
